import { Overlay } from '@eti/components';
import LoungeDrawerContent from './LoungeDrawerContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LoungeDrawer = _ref => {
  let {
    drawerText,
    isOpen,
    setOpen,
    loungeInfo
  } = _ref;
  return loungeInfo ? /*#__PURE__*/_jsxs(Overlay.Drawer, {
    dataTestId: "airport-drawer",
    handleClose: () => setOpen(false),
    id: "lounge-info-drawer",
    isOpen: isOpen,
    children: [/*#__PURE__*/_jsx(Overlay.Header, {
      onClose: () => setOpen(false),
      title: loungeInfo.loungeName
    }), /*#__PURE__*/_jsx(Overlay.Content, {
      children: /*#__PURE__*/_jsx(LoungeDrawerContent, {
        drawerText: drawerText,
        loungeInfo: loungeInfo
      })
    })]
  }) : null;
};
export default LoungeDrawer;
//# sourceMappingURL=LoungeDrawer.js.map